/** The activity log's URL search params (kept out of the lazily loaded page). */

/** The journey's filter chips (GET /admin/people/{id}/journey?group=). */
export const JOURNEY_GROUPS = ["pages", "actions", "sign_ins", "payments", "messages"] as const;
export type JourneyGroup = (typeof JOURNEY_GROUPS)[number];

export interface ActivityLogSearch {
  /** The person picked: their journey, and audit rows by or about them. */
  person?: number;
  /** With a person: their timeline (default) or the audit rows only. */
  view?: "audit";
  show?: JourneyGroup;
  action?: string;
  from?: string;
  to?: string;
  page?: number;
}

const DAY = /^\d{4}-\d{2}-\d{2}$/;

/** The URL's search params (admin/sections.tsx). */
export function parseActivityLogSearch(s: Record<string, unknown>): ActivityLogSearch {
  const str = (v: unknown) => (typeof v === "string" && v ? v : undefined);
  const person = Number(s.person);
  const page = Number(s.page);
  const from = str(s.from);
  const to = str(s.to);
  const action = str(s.action);
  const show = str(s.show);
  return {
    ...(Number.isInteger(person) && person > 0 ? { person } : {}),
    ...(s.view === "audit" ? { view: "audit" as const } : {}),
    ...(show && (JOURNEY_GROUPS as readonly string[]).includes(show)
      ? { show: show as JourneyGroup }
      : {}),
    ...(action && action.length <= 60 ? { action } : {}),
    ...(from && DAY.test(from) ? { from } : {}),
    ...(to && DAY.test(to) ? { to } : {}),
    ...(Number.isInteger(page) && page > 1 ? { page } : {}),
  };
}
